const API_BASE = process.env.REACT_APP_API_URL || 'https://gt-4zdp.onrender.com';
export default API_BASE;
